/**
 * Safe post-login destination. Email deep links use ?redirect=;
 * ProtectedRoute uses location.state.from.
 */
export function resolvePostAuthPath({ redirectParam, fromLocation } = {}) {
  const fromState =
    fromLocation && typeof fromLocation.pathname === 'string'
      ? `${fromLocation.pathname}${fromLocation.search || ''}`
      : '';
  const candidate = redirectParam || fromState || '';
  if (!candidate || typeof candidate !== 'string') return '/dashboard';
  if (!candidate.startsWith('/') || candidate.startsWith('//')) return '/dashboard';
  return candidate;
}
